import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { EventViewModel } from '../../../models-views/event.view.model';
import { BehaviorSubject, debounceTime, Subject } from 'rxjs';
import { EventNoteModel, EventNoteResponseModel,FeedbackResponseModel,feedbackVendorResponseModel } from '../../../models/event.model';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import LoginModel from '../../../models/user.model';
import { AppCommon } from '../../../providers/app-common';

@Component({
  selector: 'app-cet-notes',
  standalone: false,
  templateUrl: './cet-notes.component.html',
  styleUrl: './cet-notes.component.scss'
})
export class CetNotesComponent implements OnChanges {

  notesList = [];
  @Input('eventId') eventId: string | null = null;
  eventNoteResponseModel = new BehaviorSubject<EventNoteResponseModel>(
    new EventNoteResponseModel()
  );
   feedbackResponseModel = new BehaviorSubject<FeedbackResponseModel>(
    new FeedbackResponseModel()
  );
   feedbackVendorResponseModel = new BehaviorSubject<feedbackVendorResponseModel>(
    new feedbackVendorResponseModel()
  );


  loading:boolean = false
  page_size: number = 30;
  page_number: number = 1;
  searchValue: string = '';
  searchValue$ = new Subject();
  isVisibleModal: boolean = false;
  form: FormGroup;
  loginModel = new BehaviorSubject<LoginModel>(new LoginModel());
  // Tag shortcuts to quickly add
  tagShortcuts = [
    { text: 'Important', color: '#ff8344' },
    { text: 'Follow-up', color: '#2db7f5' },
    { text: 'Info', color: '#87d068' },
    { text: 'Urgent', color: '#f60404' }
  ];

 // -------- FEEDBACK --------


  feedbackList: any[] = [];
  loadingFeedback = false;
  searchValueFeedback = '';
  searchValueFeedback$ = new Subject();
  isVisibleFeedbackModal = false;
  feedbackForm: FormGroup;
  selectedEditFeedback: any | null = null;
  collapsedNotes = true;
  collapsedFeedback = false;
  vendorList:any= [];
  hasActionsColumn: boolean = false;


  constructor(private modalService: NzModalService, private vm: EventViewModel,
    private route: ActivatedRoute, private fb: FormBuilder,
  ) {
    this.loginModel.next(AppCommon.getloggedInObject());
    this.searchValue$.pipe(debounceTime(500)).subscribe(name => {
      this.page_number = 1;
      this.getData();
    })
    this.form = this.fb.group({
      note: ['', Validators.required],
      tags: this.fb.array([]) // initialize the form array
    });

    this.feedbackForm = this.fb.group({
    vendor: [null, Validators.required],
    feedback: [''],
    star_rating: [null, Validators.required],
  });

    this.searchValueFeedback$.pipe(debounceTime(500)).subscribe(() => {
      this.page_number = 1;
      this.getFeedbackData();
    });


  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['eventId'] && changes['eventId'].currentValue != null) {
      // console.log('CetNotesComponent received eventId from parent:', this.eventId);
    }
  }

  ngOnInit(): void {
    // this.eventId = Number(this.route.snapshot.paramMap.get('id'));
    this.vm.parentCetNotesComponent = this;
    this.vm.subscribeToEventNote(this.eventNoteResponseModel);
    this.fetchVendors();
    this.vm.subscribeFeedbackVendorResponseModel(this.feedbackVendorResponseModel);
    this.getFeedbackData();
    this.vm.subscribeToFeedback(this.feedbackResponseModel);
  }

  getData() {
    this.loading = true
    this.vm.getEventNotes(this.eventId, this.searchValue, this.page_size, this.page_number);
  }

  dataReceived() {
    this.notesList = this.eventNoteResponseModel.value.results;
    this.loading = false
  }

  handleModalCancel(): void {
    this.isVisibleModal = false;
    this.form.reset();
    this.tagsFormArray.clear(); // Clear all tag controls
    this.selectedEditNote = null;
  }

  onSearch() {
    this.searchValue$.next(this.searchValue);
  }


  onAdd() {
    this.form.reset(); // Reset form values
    this.tagsFormArray.clear(); // Clear all tag controls
    this.selectedEditNote = null; // Clear edit mode
    this.isVisibleModal = true;
  }


  onSubmit() {
    if (this.form.valid) {
      let payload = this.form.value;
      payload.event = this.eventId;
      payload.tags = payload.tags.filter(tag => tag.text.trim() !== '');
      if (this.selectedEditNote) {
        payload.modified_by = this.loginModel.value.user.id;
        this.vm.updateEventNote(this.selectedEditNote.id, payload);
      } else {
        payload.created_by = this.loginModel.value.user.id;
        this.vm.createEventNote(payload);
      }

    }
  }

  get tagsFormArray(): FormArray {
    return this.form.get('tags') as FormArray;
  }


  addTag(): void {
    this.tagsFormArray.push(
      this.fb.group({
        text: [''],
        color: ['#ff5500'] // default color
      })
    );
  }

  removeTag(index: number): void {
    this.tagsFormArray.removeAt(index);
  }

  addTagShortcut(shortcut: { text: string; color: string }): void {
    const exists = this.tagsFormArray.controls.some(
      ctrl => ctrl.get('text')?.value.toLowerCase() === shortcut.text.toLowerCase()
    );

    if (!exists) {
      this.tagsFormArray.push(
        this.fb.group({
          text: [shortcut.text],
          color: [shortcut.color]
        })
      );
    }
  }

  noteCreated() {
    this.handleModalCancel();
    this.getData();
  }

  noteUpdated() {
    this.handleModalCancel();
    this.getData();
  }

  noteDeleted() {
    this.getData();
  }

  selectedEditNote: EventNoteModel | null = null;
  onEdit(note: EventNoteModel) {
    this.selectedEditNote = note;
    this.tagsFormArray.clear();

    note.tags.forEach(tag => {
      this.tagsFormArray.push(
        this.fb.group({
          text: [tag.text],
          color: [tag.color]
        })
      );
    });

    this.form.patchValue({
      note: note.note
    });
    this.isVisibleModal = true;
  }

  deleteNote(note: EventNoteModel) {
    // this.modalService.confirm({
    //   nzTitle: 'Are you sure delete "' + note.note + '"?',
    //   nzContent: '<b style="color: red;">If you delete this, you will no longer be able restore it.</b>',
    //   nzOkText: 'Yes',
    //   nzOkType: 'primary',
    //   nzOkDanger: true,
    //   nzOnOk: () => this.vm.deleteEventNote(note.id),
    //   nzCancelText: 'No',
    //   nzOnCancel: () => console.log('Cancel')
    // });
     this.vm.deleteEventNote(note.id)
  }

  // -------- FEEDBACK --------


  getFeedbackData() {
    this.loadingFeedback = true;
    this.vm.getFeedbacks(this.eventId,this.searchValueFeedback,this.page_size,this.page_number);
  }

  fetchVendors(name: string = '', page: number = 1, page_size: number = 100) {
    const caller = 'cet-notes-component';
    this.vm.getVendors(name, page, page_size, caller, this.eventId ? Number(this.eventId) : undefined);
  }

  vendorRecieved() {
    this.vendorList = this.feedbackVendorResponseModel.value.results || [];
  }

  get vendorOptions() {
    return this.vendorList.map(vendor => ({
      label: vendor.name, // Display name in dropdown
      value: vendor.id    // Form value
    }));
  }

  onSearchFeedback() {
    this.searchValueFeedback$.next(this.searchValueFeedback);
  }

  onAddFeedback() {
    this.isVisibleFeedbackModal = true;
  }

  onSubmitFeedback() {
    if (this.feedbackForm.valid) {
      const formValue = this.feedbackForm.value;

      if (this.selectedEditFeedback) {
        const payload = {
          feedback: formValue.feedback,
          rating: formValue.star_rating * 2, // convert 0–5 → 0–10
          modified_by:this.loginModel.value.user.id,
          event: this.eventId,
          vendor: formValue.vendor,
        };
        this.vm.updateFeedback(this.selectedEditFeedback.id, payload);
      } else {
        const payload = {
          feedback: formValue.feedback,
          rating: formValue.star_rating * 2, // convert 0–5 → 0–10
          created_by:this.loginModel.value.user.id,
          event: this.eventId,
          vendor: formValue.vendor,
        };
        payload.created_by = this.loginModel.value.user.id;
         this.vm.createFeedback( payload);
      }

      this.handleModalCancelFeedback();
    }
  }

  // Callbacks triggered from the model
  feedbackCreated() {
    this.handleModalCancelFeedback();
    this.getFeedbackData();
  }

  feedbackUpdated() {
    this.handleModalCancelFeedback();
    this.getFeedbackData();
  }

  feedbackDeleted() {
    this.getFeedbackData(); // Refresh feedback list after delete
  }


  feedbackDataReceived() {
    this.feedbackList = this.feedbackResponseModel.value.results;
    const userId = this.loginModel.value.user.id;
    this.hasActionsColumn = this.feedbackList.some(f => f.created_by === userId);
    this.loadingFeedback = false
  }

  handleModalCancelFeedback(): void {
    this.isVisibleFeedbackModal = false;
    this.feedbackForm.reset();
    this.selectedEditFeedback = null;
  }

  onEditFeedback(feedback: any) {
    this.selectedEditFeedback = feedback;
    this.feedbackForm.patchValue({
      feedback: feedback.feedback,
      star_rating: feedback.rating / 2,
      vendor: feedback.vendor,
    });
    this.isVisibleFeedbackModal = true;
  }

  deleteFeedback(feedback: any) {
    // this.modalService.confirm({
    //   nzTitle: 'Are you sure delete "' + feedback.feedback + '"?',
    //   nzContent:
    //     '<b style="color: red;">If you delete this, you will no longer be able to restore it.</b>',
    //   nzOkText: 'Yes',
    //   nzOkType: 'primary',
    //   nzOkDanger: true,
    //   nzOnOk: () =>  this.vm.deleteFeedback(feedback.id),
    //   nzCancelText: 'No',
    //   nzOnCancel: () => console.log('Cancel')
    // });
    this.vm.deleteFeedback(feedback.id)
  }

  onStarChange(value: number) {
    this.feedbackForm.get('star_rating')?.setValue(value);
  }





}
